import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Remittance } from '../../../../../models/remittances/remittance';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { ContributionSummary } from '../../../../../models/remittances/contribution-summary';
import { RemittanceTransaction } from '../../../../../models/transactions/remittance-transaction';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-accordion-remittance-item',
  templateUrl: './accordion-remittance-item.component.html',
  styleUrls: ['./accordion-remittance-item.component.scss']
})
export class AccordionRemittanceItemComponent implements OnChanges {
  @Input() remittance!: Remittance;
  @Input() transactions!: RemittanceTransaction[];
  @Input() contributionSummary!: ContributionSummary;
  @Input() showActionButton = true;
  @Input() showEmployerInfo = true;
  @Input() showSource = true;
  @Input() accordionInitExpanded = false;
  @Input() isLoading = false;
  @Input() showTransactions = true;
  @Output() viewTransactionClick: EventEmitter<RemittanceTransaction> = new EventEmitter();

  private _accordionExpanded = new BehaviorSubject<boolean>(this.accordionInitExpanded);
  public accordionExpanded$ = this._accordionExpanded as Observable<boolean>;

  private _remittance = new BehaviorSubject<Remittance | null>(null);
  public remittance$ = this._remittance as Observable<Remittance>;

  private _transactions = new BehaviorSubject<RemittanceTransaction[]>([]);
  public transactions$ = this._transactions as Observable<RemittanceTransaction[]>;

  private _contributionSummary = new BehaviorSubject<ContributionSummary | null>(null);
  public contributionSummary$ = this._contributionSummary as Observable<ContributionSummary>;

  public transactionsToDisplay$ = combineLatest([this.transactions$, this.remittance$]).pipe(
    map(([transactions, remittance]) => {
      return remittance?.transactions ?? transactions ?? [];
    })
  );

  public setAccordionExpanded = (expanded: boolean) => this._accordionExpanded.next(expanded);

  public headerClicked(): void {
    this.accordionExpanded$.once(expanded => this._accordionExpanded.next(!expanded));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.accordionInitExpanded) this.setAccordionExpanded(this.accordionInitExpanded);
    if (changes.remittance) this._remittance.next(this.remittance);
    if (changes.transactions) this._transactions.next(this.transactions);
    if (changes.contributionSummary) this._contributionSummary.next(this.contributionSummary);
  }
}
